"use client";

import { c as _c } from "react/compiler-runtime";
import { BUNNY_VIDEO_PULL_ZONE_URL } from "../../utils";
import { HLSPlayer } from "@local/hls-player/src";
import type { HLSLoadStrategy } from "@local/hls-player/src";
import { cn } from "@local/utils/src/cn";
export interface VideoTrackProps {
  src: string;
  srcLang?: string;
  label?: string;
  kind?: "captions" | "subtitles" | "descriptions" | "chapters" | "metadata";
  default?: boolean;
}
export interface VideoProps {
  videoId: string;
  poster?: string;
  muted?: boolean;
  loop?: boolean;
  controls?: boolean;
  className?: string;
  autoplay?: boolean;
  /** Set to true for LCP videos to prioritize loading */
  priority?: boolean;
  /** When to begin fetching HLS segments — see HLSPlayer. Defaults to "eager". */
  loadStrategy?: HLSLoadStrategy;
  tracks?: VideoTrackProps[];
}
export const VideoPlayer = t0 => {
  const $ = _c(13);
  const {
    videoId,
    poster: t1,
    muted: t2,
    loop: t3,
    controls: t4,
    className: t5,
    autoplay: t6,
    priority: t7,
    loadStrategy: t8,
    tracks
  } = t0;
  const poster = t1 === undefined ? "" : t1;
  const muted = t2 === undefined ? true : t2;
  const loop = t3 === undefined ? false : t3;
  const controls = t4 === undefined ? true : t4;
  const className = t5 === undefined ? "absolute top-0 z-20 border-0" : t5;
  const autoplay = t6 === undefined ? false : t6;
  const priority = t7 === undefined ? false : t7;
  const loadStrategy = t8 === undefined ? "eager" : t8;
  if (!videoId) {
    return null;
  }
  const t9 = `${BUNNY_VIDEO_PULL_ZONE_URL}${videoId}/playlist.m3u8`;
  let t10;
  if ($[0] !== className) {
    t10 = cn(className, "aspect-video h-full w-full object-cover");
    $[0] = className;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  let t11;
  if ($[2] !== autoplay || $[3] !== controls || $[4] !== loadStrategy || $[5] !== loop || $[6] !== muted || $[7] !== poster || $[8] !== priority || $[9] !== t10 || $[10] !== t9 || $[11] !== tracks) {
    t11 = <HLSPlayer src={t9} poster={poster} autoPlay={autoplay} controls={controls} muted={muted} loop={loop} priority={priority} loadStrategy={loadStrategy} tracks={tracks} className={t10} />;
    $[2] = autoplay;
    $[3] = controls;
    $[4] = loadStrategy;
    $[5] = loop;
    $[6] = muted;
    $[7] = poster;
    $[8] = priority;
    $[9] = t10;
    $[10] = t9;
    $[11] = tracks;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};